// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"95":"c9be6f0bddb0ebc76a53","518":"dadf8feceb45a84fc0a6","879":"2a23906d3a8cee97e43c"}[chunkId] + ".js";
};